import { render, staticRenderFns } from "./collectionAppList.vue?vue&type=template&id=4eba1a51&scoped=true"
import script from "./collectionAppList.vue?vue&type=script&lang=js"
export * from "./collectionAppList.vue?vue&type=script&lang=js"
import style0 from "./collectionAppList.vue?vue&type=style&index=0&id=4eba1a51&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba1a51",
  null
  
)

export default component.exports